import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface ContentTypeTileProps {
	icon: LucideIcon;
	label: string;
	description?: string;
	active: boolean;
	onClick: () => void;
	compact?: boolean;
	disabled?: boolean;
}

export function ContentTypeTile({
	icon: Icon,
	label,
	description,
	active,
	onClick,
	compact,
	disabled,
}: ContentTypeTileProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={cn(
				'flex flex-col gap-2 rounded-[10px] border p-3.5 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-50',
				active
					? 'border-loomlite-purple bg-loomlite-purple/10'
					: 'border-loomlite-border bg-loomlite-card-alt hover:border-loomlite-border-strong',
				compact && 'items-center text-center',
			)}
		>
			<div
				className={cn(
					'flex items-center justify-center rounded-lg',
					compact ? 'h-7 w-7' : 'h-8 w-8',
					active ? 'bg-loomlite-purple/25 text-[#D9A9F5]' : 'bg-slate-400/10 text-loomlite-muted',
				)}
			>
				<Icon className={compact ? 'h-4 w-4' : 'h-[18px] w-[18px]'} />
			</div>
			<div className={cn('text-[13px] font-semibold text-loomlite-text', compact && 'text-[11px]')}>
				{label}
			</div>
			{!compact && description && (
				<div className="text-[11px] leading-snug text-loomlite-dim">{description}</div>
			)}
		</button>
	);
}
